// extracted by css-extract-rspack-plugin
export default {"suggestionPaper":"GJYMn"};